"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarIcon = void 0;
var React = require("react");
var StarImg = "https://li0.rightinthebox.com/imagegy/202101/7bcd03d2cb9c478ca597d9e2ea441cf4star.png";
exports.StarIcon = function (props) {
    var size = props.size;
    return (React.createElement("img", { src: StarImg, style: {
            width: size,
            aspectRatio: "1"
        } }));
};
